module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break"
  }, [_vm._v("Glossary")]), _vm._v(" "), _c('p', {
    staticClass: "Flush-left"
  }, [_vm._v("For readers’ convenience, the author offers the following:")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "Glossary"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Àdham(h)")]), _vm._v(": pronounced “Adam” in medieval days, now YAH dav")]), _vm._v(" "), _c('li', {
    staticClass: "Glossary"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Catriona")]), _vm._v(": Ka CHREE na")]), _vm._v(" "), _c('li', {
    staticClass: "Glossary"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Clerical hours")]), _vm._v(": Prime = 6 a.m.; Terce = 8–9 a.m.; Vespers = 4:30–6 p.m.")]), _vm._v(" "), _c('li', {
    staticClass: "Glossary"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Father Prior")]), _vm._v(": the proper form of address for lead prior of a monastery")]), _vm._v(" "), _c('li', {
    staticClass: "Glossary"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Gillichallum Roy")]), _vm._v(": Gilli HAL um; Gillichallum = “Young Malcolm”; Roy = red")]), _vm._v(" "), _c('li', {
    staticClass: "Glossary"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Glen Mòr")]), _vm._v(": the Great Glen")]), _vm._v(" "), _c('li', {
    staticClass: "Glossary"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Inver")]), _vm._v(": mouth of the river (i.e., Inverlochy; Inverness)")]), _vm._v(" "), _c('li', {
    staticClass: "Glossary"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Ivor")]), _vm._v(": EE vor")]), _vm._v(" "), _c('li', {
    staticClass: "Glossary"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Keekers")]), _vm._v(": eyes ")]), _vm._v(" "), _c('li', {
    staticClass: "Glossary"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Jack-o’-plate")]), _vm._v(": sleeveless jacket with inserted plates of iron or other padding")]), _vm._v(" "), _c('li', {
    staticClass: "Glossary"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Plaid")]), _vm._v(": pronounced “played”; an all-purpose garment from a length of wool kilted up with a belt. Wearer flings excess length over his shoulder.")]), _vm._v(" "), _c('li', {
    staticClass: "Glossary"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Sark")]), _vm._v(": long shirt (thigh length)")]), _vm._v(" "), _c('li', {
    staticClass: "Glossary"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Wheesht ")]), _vm._v("(as in “Hold your wheesht”): Be quiet")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Dedication"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("’S math an còcaire an t-acras,"), _c('br'), _vm._v("’S mairg ’ni tailleas air biadh,"), _c('br'), _vm._v("Fuarag eòrn’ a sàil mo bhroige,"), _c('br'), _vm._v("Biadh as fhearr a fhuair mi riamh."), _c('br')]), _c('br'), _vm._v("—Alexander Stewart, 12th Earl of Mar,"), _c('br'), _vm._v("September 1431")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Dedication ParaOverride-2",
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_vm._v("Hunger is a good cook,"), _c('br'), _vm._v("It is pitiful to scorn food,"), _c('br'), _vm._v("Cold barley gruel from the heel of my shoe,"), _c('br'), _vm._v("The best food I ever got."), _c('br'), _c('br'), _vm._v("—English translation by David Gressett,"), _c('br'), _vm._v("master Gaelic instructor, 2016")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-992faeba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Untitled-1-2.vue
// module id = 72
// module chunks = 0